import Button from '../Button/Button';
import './Header.scss';
import SimpleSlider from './SimpleSlider';

function Header() {
    return (
        <header className="header">
            <div className="header__wrapper">
                <div className="container">
                    <a target="_blank" href="https://sennheiser.ru/">
                        <img className="pic_brand" src="/img/sen.svg" alt="Sennheiser"></img>
                    </a>
                    <a target="_blank" href="https://pult.ru/">
                        <img className="pic_logo" src="/img/pult_header.svg" alt="PULT.RU"></img>
                    </a>
                </div>
            </div> 
            <div className="container">
                <div className="slider">
                    <SimpleSlider />
                </div>
               <Button text="читать статью" href="https://www.pult.ru/articles/naushniki/tws-ot-sennheiser-dostupnoe-kachestvo/"/>
            </div>
        </header>
    )
}
export default Header;
